export const ANALYSIS_TYPES = [5];
export const COMPLEX_PROGRAM_TYPES = [7, 11];
export const MEDICAL_SERVICES_TYPES = [6, 8, 9, 10];